import { Component, ViewChild } from "@angular/core";
import { NavController, Content, Loading, Events } from "ionic-angular";
import { Store } from "@ngrx/store";

import { AppState } from "../../app/app.reducer";
import { IdolsPage } from "../idols/idols";
import { MarketplacePage } from "../marketplace/marketplace";
import { ReceiveautographsPage } from "../receiveautographs/receiveautographs";
import { Token, Wallet, User } from "../../app/app.models";
import { TokensFetchAction, WalletFetchAction } from "../../app/app.actions";
import { WalletPage } from "../wallet/wallet";
import { HomePaginService } from "../../services/home.pagin.service";
import { NodeService } from "../../services/node.service";
import { WalletService } from "../../services/wallet.service";
import { FcmService } from "../../services/fcm.service";
import { ToastController, Platform, AlertController } from "ionic-angular";
import { tap } from "rxjs/operators";
import { ConfigService } from "../../services/config.service";
import { AppUtilities } from "../../app/app.utilities";
import * as firebase from "firebase";
import { TranslateService } from "@ngx-translate/core";
import { FirebaseService } from "../../services/firebase.service";
import { AuthService } from "../../services/auth.service";
import { FannelsListPage } from "../fannels-list/fannels-list";
import { HelpPage } from "../help/help";
//import { StartPage } from '../start/start';
import { GoogleAnalytics } from "@ionic-native/google-analytics";

@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage {
  public fannelsListPage = FannelsListPage;
  public idolsPage = IdolsPage;
  public marketplacePage = MarketplacePage;
  public reciveautographsPage = ReceiveautographsPage;
  public refresh;
  public tokens$: Token[] = [];
  public tokensAll$: Token[] = [];
  public wallet$: Wallet;
  public walletPage = WalletPage;
  moreAssets: boolean = false;
  public user$: User;
  @ViewChild(Content)
  content: Content;
  haveFannels = { have: false };
  ios: boolean;

  constructor(
    public navCtrl: NavController,
    public store: Store<AppState>,
    private homePaginService: HomePaginService,
    private walletService: WalletService,
    private fcm: FcmService,
    private toastCtrl: ToastController,
    private platform: Platform,
    public alertCtrl: AlertController,
    private configService: ConfigService,
    private utilities: AppUtilities,
    private translateService: TranslateService,
    private firebaseService: FirebaseService,
    private authService: AuthService,
    public events: Events,
    private ga: GoogleAnalytics
  ) {
    if (this.platform.is("ios")) {
      this.ios = true;
    } else {
      this.ios = false;
    }

    this.ios = false;

    this.user$ = this.authService.getUser();
    //this.notifications();

    this.store.select("wallet").subscribe((wallet: Wallet) => {
      if (wallet && wallet.address) {
        this.wallet$ = wallet;
        // Get tokens if first call
        if (this.tokensAll$ && !this.tokensAll$.length) {
        }
      }
    });

    this.store.dispatch(new WalletFetchAction(this.user$));
    var idiom = this.configService.getIdiom();
    if (idiom == "en") this.utilities.loading("Checking Blockchain");

    if (idiom == "es") this.utilities.loading("Consultando Blockchain");
    this.homePaginService
      .getAssetsIdsOwnedBy(this.walletService.getAddress())
      .then((assets: any[]) => {
        this.utilities.loadingDismiss();
        if (assets) {
          if (assets.length > 0) {
            this.moreAssets = this.homePaginService.getMoreAssets();
            this.tokens$ = assets;
            this.events.publish("tokens", this.tokens$);
          } else {
            this.events.publish("tokens", []);
          }
        } else {
          this.moreAssets = false;
          var tokens = [];
          this.events.publish("tokens", tokens);
        }
      });
  }

  loadMoreAssets($event) {
    console.log("loadMoreAssets ", this.moreAssets);
    if (this.content.directionY == "down" && this.moreAssets) {
      console.log("Event ", $event);
      var idiom = this.configService.getIdiom();
      if (idiom == "en") this.utilities.loading("Checking Blockchain");

      if (idiom == "es") this.utilities.loading("Consultando Blockchain");
      setTimeout(() => {
        this.homePaginService.getBlockAssets().then((assets) => {
          if (assets.length > 0) {
            for (let asset of assets) {
              this.tokens$.push(asset);
            }
            this.events.publish("tokens", this.tokens$);
            this.moreAssets = this.homePaginService.getMoreAssets();
          } else {
            this.moreAssets = this.homePaginService.getMoreAssets();
            this.events.publish("tokens", []);
          }
          this.utilities.loadingDismiss();
          $event.complete();
        });
      }, 1000);
    } else {
      console.log("loadMoreAssets else ", this.moreAssets);
      $event.complete();
    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad HomePage");
    this.ga
      .trackView("HomePage")
      .then(() => {})
      .catch((e) => console.log(e));

    /** if (this.configService.getShowSeedsMessage() === "yes") {
      var alert_seeds_message = this.translateService.instant(
        "home.alert_seeds_message"
      );
      var alert_seeds_accept = this.translateService.instant(
        "home.alert_seeds_accept"
      );
      var idioma = this.configService.getIdiom();

      let alert;

      alert = this.alertCtrl.create({
        enableBackdropDismiss: false,
        subTitle: alert_seeds_message,
        buttons: [
          {
            text: alert_seeds_accept,
            role: "cancel",
            handler: () => {
              console.log("Aceptar");
              this.configService.setShowSeedsMessage("no");
            }
          }
        ]
      });
      alert.present();
    } */
  }

  ionViewWillEnter() {
    /*this.walletService.getShowAlert().then(val => {
      if (val) {
        console.log("get show Alert");
        this.openAlertNewSeedsGenerated();
      }
    });*/
    this.fannelsOpen(this.haveFannels);
    console.log("have fannels ", this.haveFannels);

    this.events.subscribe("sellWatacard", (response) => {
      if (response) {
        this.homePaginService
          .getAssetsIdsOwnedBy(this.walletService.getAddress())
          .then((assets: any[]) => {
            this.utilities.loadingDismiss();
            if (assets) {
              if (assets.length > 0) {
                this.moreAssets = this.homePaginService.getMoreAssets();
                this.tokens$ = assets;
                this.events.publish("tokens", this.tokens$);
              } else {
                this.events.publish("tokens", []);
              }
            } else {
              this.moreAssets = false;
              var tokens = [];
              this.events.publish("tokens", tokens);
            }
          });
      }
    });
  }

  notifications() {
    // Get a FCM token
    this.fcm.getToken(this.user$);
    this.fcm
      .listenToNotifications()
      .pipe(
        tap((msg: any) => {
          let messageText: string;
          if (this.platform.is("android")) {
            messageText = msg.body;
          }

          if (this.platform.is("ios")) {
            messageText = msg.aps.alert.body;
          }

          const toast = this.toastCtrl.create({
            message: messageText,
            duration: 3000,
            position: "top",
          });
          toast.present();
        })
      )
      .subscribe();
  }

  doRefresh($event) {
    this.refresh = $event;
    console.log("Refresh action " + this.walletService.getAddress());
    this.homePaginService
      .getAssetsIdsOwnedBy(this.walletService.getAddress())
      .then((assets: any[]) => {
        console.log("Assets array " + JSON.stringify(assets));
        if (assets) {
          console.log("if asset Assets array ");
          if (assets.length > 0) {
            this.moreAssets = this.homePaginService.getMoreAssets();
            this.events.publish("tokens", this.tokens$);
            this.tokens$ = assets;
          } else {
            this.tokens$ = assets;
            this.events.publish("tokens", this.tokens$);
            console.log("asset[] =0 " + this.tokens$);
            this.moreAssets = false;
          }
        }
        $event.complete();
      });
  }

  reciveautograph() {
    this.navCtrl.push(WalletPage);
  }

  fannelsOpen(haveFannels) {
    console.log("opne fanel");

    //production
    var db = firebase.database().ref("/prod_fannels");
    //test
    //var db = firebase.database().ref('/fannels');
    db.on("value", function (snapshot) {
      console.log("have fannels var ", haveFannels);
      haveFannels.have = false;
      var fannels = snapshot.val();
      var keys = Object.keys(fannels);
      console.log("fannels ", fannels, " keys ", keys);
      for (var x = 0; x < keys.length; x++) {
        var item = fannels[keys[x]];
        var itemKeys = Object.keys(item);
        console.log(
          "Fannels item ",
          item,
          " item finish ",
          item[itemKeys[0]].finish
        );
        for (var z = 0; z < itemKeys.length; z++) {
          if (item[itemKeys[z]].finish == false) {
            if (item[itemKeys[z]].periode > Date.now()) {
              haveFannels.have = true;
              break;
            }
          }
        }
        if (haveFannels.have == true) {
          break;
        }
      }
    });
  }

  openAlertNewSeedsGenerated() {
    var ALERT_NEW_SEED_TITLE = this.translateService.instant(
      "ALERT_NEW_SEED_TITLE"
    );
    var ALERT_NEW_SEED_MESSAGE = this.translateService.instant(
      "ALERT_NEW_SEED_MESSAGE"
    );
    var ALERT_NEW_SEED_TENGO = this.translateService.instant(
      "ALERT_NEW_SEED_TENGO"
    );
    var ALERT_NEW_SEED_NUEVA_GUARDAR = this.translateService.instant(
      "ALERT_NEW_SEED_NUEVA_GUARDAR"
    );

    let alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: ALERT_NEW_SEED_TITLE,
      message: ALERT_NEW_SEED_MESSAGE,
      buttons: [
        {
          text: this.translateService.instant("ALERT_INFO_SEED"),
          cssClass: "alert_btn_title",
          handler: () => {
            this.openAlertSeedsInfo();
          },
        },
        {
          text: ALERT_NEW_SEED_NUEVA_GUARDAR,
          handler: () => {
            this.walletService.setShowAlert(false);
            this.navCtrl.push(WalletPage, { segment: "seeds" });
            console.log("Ya tengo una semillay");
          },
        },
        {
          text: ALERT_NEW_SEED_TENGO,
          handler: () => {
            this.walletService.setShowAlert(false);
            this.setYourSeeds();
            console.log("Guardar está semilla de forma segura");
          },
        },
      ],
    });
    alert.present();
  }

  openAlertSeedsInfo() {
    const alert = this.alertCtrl.create({
      subTitle: this.translateService.instant("SEEDS_INFO"),
      buttons: [
        {
          text: "OK",
          handler: () => {
            this.openAlertNewSeedsGenerated();
          },
        },
      ],
    });
    alert.present();
  }

  setYourSeeds() {
    var IMPORT_SEED = this.translateService.instant("IMPORT_SEED");
    var WRITE_SEED = this.translateService.instant("WRITE_SEED");
    var GUARDAR = this.translateService.instant("GUARDAR");
    var CANCELAR = this.translateService.instant("CANCELAR");
    let alert = this.alertCtrl.create({
      title: IMPORT_SEED,
      inputs: [
        {
          name: "seed",
          placeholder: WRITE_SEED,
        },
      ],
      buttons: [
        {
          text: CANCELAR,
          role: "cancel",
          handler: (data) => {
            console.log("Cancel clicked ", data);
          },
        },
        {
          text: GUARDAR,
          handler: (data) => {
            console.log("data setyourSeeds ", data);
            this.walletService.updateSeeds(data.seed).then(() => {
              this.firebaseService.updateUserAddresData(
                this.user$.uid,
                this.walletService.getAddress()
              );
              this.store.dispatch(new WalletFetchAction(this.user$));
              this.update();
            });
          },
        },
      ],
    });
    alert.present();
  }

  update() {
    //this.refresh = $event;
    var idiom = this.configService.getIdiom();
    if (idiom == "en") this.utilities.loading("Checking Blockchain");

    if (idiom == "es") this.utilities.loading("Consultando Blockchain");
    console.log("Refresh action " + this.walletService.getAddress());
    this.homePaginService
      .getAssetsIdsOwnedBy(this.walletService.getAddress())
      .then((assets: any[]) => {
        console.log("Assets array " + JSON.stringify(assets));
        if (assets) {
          console.log("if asset Assets array ");
          if (assets.length > 0) {
            this.moreAssets = this.homePaginService.getMoreAssets();
            this.events.publish("tokens", this.tokens$);
            this.tokens$ = assets;
          } else {
            this.tokens$ = assets;
            this.events.publish("tokens", this.tokens$);
            console.log("asset[] =0 " + this.tokens$);
            this.moreAssets = false;
          }
        }
        //$event.complete();
        this.utilities.loadingDismiss();
      })
      .catch((e) => {
        this.utilities.loadingDismiss();
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts